export const getStyled = (theme) => ({
  mainPaper: {
    flex: 1,
    width: 'fit-content',
    padding: theme.padding,
    overflowY: 'auto',
    ...theme.custom.scrollbarStyles,
    backgroundColor: theme.custom.colors.defaultBackground,

    borderColor: theme.palette.mode === 'light' ? '#192734' : '#8C939A',
    color: ` ${theme.custom.colors.text} !important`,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
      whiteSpace: 'nowrap',
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiIconButton-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiAvatar-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },
});
